import React, { useEffect, useState, useMemo } from "react";
import { Table } from "semantic-ui-react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 as api } from "../../../../services/apis";
import {
  Container,
  Content,
  Center,
  Field,
  Link,
  UserData,
  SubscriberContainer,
  Button,
  MainContainer,
} from "./styled";
import {
  datePattern,
  financialUsers,
  formatValue,
  TIUsers,
} from "../../../../utils/Utils";
import { useRouter } from "../../../../hooks/router";
import { BiLinkExternal } from "react-icons/bi";
import Status from "../../../../components/Admin/Pagarme/Status";
import ModalCharge from "../../../../components/Admin/Pagarme/ModalRe";
import {
  Button as ButtonSemantic,
  Modal,
  Icon,
  Header,
  TextArea,
} from "semantic-ui-react";
import swal from "sweetalert";
import { smallDateFormat } from "../../../../utils/Utils";
import { PLAN_PAYMENT_METHODS } from "../../../../constants";
import { getUserNode } from "../../../../services/auth_node";

const REMOVE_ALL_STATUS = {
  HAVE_ACCESS: 0,
  CANCEL_AND_REMOVE_ACCESS: 1,
  REMOVE_ONLY_ACCESS: 2,
  CANCEL_AND_KEEP_ACCESS: 3,
};

const removeAllStatusOptions = [
  {
    id: REMOVE_ALL_STATUS.CANCEL_AND_REMOVE_ACCESS,
    label: "Cancelar assinatura pagarme e remover acesso",
    tooltip: "Cancela a assinatura na pagarme e remove o acesso do aluno",
    canceledText: "Cancelamento da assinatura na pagarme e remoção do acesso",
  },
  {
    id: REMOVE_ALL_STATUS.REMOVE_ONLY_ACCESS,
    label: "Manter assinatura pagarme ativa e remover acesso",
    tooltip:
      "Mantem a assinatura ativa na pagarme e remove somente o acesso do aluno",
    canceledText: "Bloqueio apenas dos cursos",
  },
  {
    id: REMOVE_ALL_STATUS.CANCEL_AND_KEEP_ACCESS,
    label: "Cancelar assinatura pagarme e manter acesso",
    tooltip: "Cancela a assinatura na pagarme e mantem o acesso do aluno",
    canceledText:
      "Somente cancelamento da assinatura na pagarme e acesso mantido",
  },
];

const PagarmeAssinante = () => {
  const [adminUserEmail, setAdminUserEmail] = useState("");
  const [aluno, setAluno] = useState(null);
  const [charge, setCharge] = useState(null);
  const [open, setOpen] = useState(false);
  const [removeAllStatus, setRemoveAllStatus] = useState(
    REMOVE_ALL_STATUS.REMOVE_ONLY_ACCESS
  );
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingManualBilling, setLoadingManualBilling] = useState(false);

  const router = useRouter();

  useEffect(() => {
    const user = getUserNode();

    setAdminUserEmail(user.email);
  }, []);

  useEffect(() => {
    const { id_pessoa, id_assinatura } = router.query;

    try {
      api
        .get(`/pagarme/assinante/${id_pessoa}?subscription=${id_assinatura}`)
        .then((res) => {
          setAluno({
            ...res.data,
          });
          setLoading(true);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);

  async function onRemoveSubscription() {
    const { id_assinatura } = router.query;

    if (id_assinatura) {
      const payload = {
        description,
        id_assinatura,
        removeAllStatus,
      };

      try {
        const data = await api.post(`/planos/assinatura`, payload);
        if (data.status == 200) {
          swal("Processo concluido!", "Remoção efetuada", "success");
          setOpen(false);
          window && window.location.reload();
        }
      } catch (error) {
        swal(
          "Processo não executado!",
          "Remoção não efetuada. Fale com o TI",
          "error"
        );
      }
    }
  }

  async function resumeAccess() {
    const { id_assinatura } = router.query;

    if (id_assinatura) {
      const payload = {
        description,
        id_assinatura,
      };

      try {
        const data = await api.post(
          `/planos/assinatura/resume-accesss`,
          payload
        );
        if (data.status == 200) {
          swal("Processo concluido!", "Cursos reabilitados", "success");
          setOpen(false);
          window && window.location.reload();
        }
      } catch (error) {
        swal(
          "Processo não executado!",
          "Reabilitação não efetuada. Fale com o TI",
          "error"
        );
      }
    }
  }

  const toggleManualBilling = async () => {
    const { id_assinatura } = router.query;

    setLoadingManualBilling(true);

    try {
      const response = await api.post(
        `/admin/pagarme/assinante/${aluno.id_pessoa}/manual_billing`,
        {
          id_assinatura,
        }
      );

      setAluno((prev) => ({
        ...prev,
        manual_billing: response.data?.manual_billing,
      }));

      swal(
        "Sucesso",
        "Faturamento da assinatura alterado com sucesso",
        "success"
      );
    } catch (error) {
      swal(
        "Erro",
        `Houve um erro ao alterar o faturamento manual: ${error?.response?.data?.message}`,
        "error"
      );
    } finally {
      setLoadingManualBilling(false);
    }
  };

  const subscriptionPaymentMethod = useMemo(() => {
    return PLAN_PAYMENT_METHODS.find(
      (method) => method.value === aluno?.payment_method
    )?.text;
  }, [aluno]);

  const canCancelSubscription = [...TIUsers, ...financialUsers].includes(
    adminUserEmail
  );

  if (loading) {
    return (
      <MainContainer>
        <AdminMenu />
        <Container>
          <ModalCharge
            aluno={aluno}
            charge={charge}
            handleClose={() => setCharge(null)}
          />
          <Modal
            closeIcon
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
          >
            <Header
              icon="question circle outline"
              content="Cancelamento de assinatura"
            />
            <Modal.Content
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "2rem",
                flexDirection: "column",
              }}
            >
              {Object.keys(aluno.cancelled).length !== 0 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      gap: "2rem",
                      flexDirection: "column",
                    }}
                  >
                    <p>
                      Tipo de cancelamento:{" "}
                      <strong>
                        {removeAllStatusOptions.find(
                          (option) =>
                            +option.id === +aluno?.cancelled.remove_all
                        )?.canceledText || "Desconhecido"}
                      </strong>
                    </p>
                    <p>
                      Descrição: <strong>{aluno?.cancelled.description}</strong>
                    </p>
                    <p>
                      Data da efetivação:{" "}
                      <strong>
                        {smallDateFormat(aluno?.cancelled.created_at)}
                      </strong>
                    </p>
                    {aluno?.cancelled.remove_all === 2 && (
                      <>
                        <TextArea
                          style={{
                            minWidth: "400px",
                            width: "100%",
                            padding: "1rem",
                          }}
                          placeholder="Descreva o motivo da retomada: "
                          onChange={(e) => setDescription(e.target.value)}
                        />

                        <ButtonSemantic
                          onClick={() => {
                            if (!description) {
                              swal(
                                "Processo Negado!",
                                "Por segurança exigimos uma descrição",
                                "error"
                              );
                              return;
                            }
                            resumeAccess();
                          }}
                        >
                          Retomar Acesso
                        </ButtonSemantic>
                      </>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.5rem",
                    }}
                  >
                    {removeAllStatusOptions.map((option) => {
                      return (
                        <label
                          key={option.id}
                          title={option.tooltip}
                          style={{ cursor: "pointer" }}
                        >
                          <input
                            name="remove-acesss"
                            type="radio"
                            checked={removeAllStatus === option.id}
                            value={option.id}
                            onChange={(e) =>
                              setRemoveAllStatus(+e.target.value)
                            }
                          />
                          <span style={{ paddingLeft: "0.5rem" }}>
                            {option.label}
                          </span>
                        </label>
                      );
                    })}
                  </div>
                  <TextArea
                    style={{
                      minWidth: "400px",
                      width: "100%",
                      padding: "1rem",
                    }}
                    placeholder="Descreva o motivo do cancelamento: "
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </>
              )}
            </Modal.Content>
            {Object.keys(aluno.cancelled).length === 0 && (
              <Modal.Actions>
                <ButtonSemantic
                  color="green"
                  onClick={() => {
                    if (!description) {
                      swal(
                        "Processo Negado!",
                        "Por segurança exigimos uma descrição",
                        "error"
                      );
                      return;
                    }
                    onRemoveSubscription();
                    return;
                  }}
                >
                  <Icon name="checkmark" /> confirmar
                </ButtonSemantic>
                <ButtonSemantic
                  color="red"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <Icon name="remove" /> cancelar
                </ButtonSemantic>
              </Modal.Actions>
            )}
          </Modal>
          {aluno && (
            <Content>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <h2>Dados do aluno</h2>
                <div style={{ display: "flex", gap: "1rem" }}>
                  <ButtonSemantic
                    title={
                      aluno?.manual_billing
                        ? "Ao desabilitar o faturamento manual, as faturas serão criadas de forma automática pela pagarme"
                        : "Ao habilitar o faturamento manual, as faturas não serão criadas de maneira automática pela pagarme"
                    }
                    color="orange"
                    basic={!aluno?.manual_billing}
                    disabled={loadingManualBilling}
                    onClick={toggleManualBilling}
                  >
                    {loadingManualBilling
                      ? "Alterando faturamento..."
                      : aluno?.manual_billing
                      ? "Desabilitar faturamento manual"
                      : "Habilitar faturamento manual"}
                  </ButtonSemantic>
                  {canCancelSubscription && (
                    <ButtonSemantic
                      color="red"
                      onClick={() => {
                        setOpen(true);
                      }}
                    >
                      {aluno.cancelled
                        ? aluno?.cancelled?.remove_all === 1
                          ? "Assinatura Cancelada"
                          : aluno.cancelled.remove_all === 2
                          ? "Acesso Removido"
                          : "Cancelar Assinatura"
                        : "Cancelar Assinatura"}
                    </ButtonSemantic>
                  )}
                </div>
              </div>
              <UserData>
                <div>
                  <Field>
                    <p>Id Aluno</p>
                    <span>{aluno.id_pessoa}</span>
                  </Field>
                  <Field>
                    <p>Nome</p>
                    <span>{aluno.name}</span>
                  </Field>
                  <Field>
                    <p>Email</p>
                    <span>{aluno.email}</span>
                  </Field>
                  <Field>
                    <p>Forma de pagamento</p>
                    <span>{subscriptionPaymentMethod}</span>
                  </Field>
                </div>
                <div>
                  <Field>
                    <p>Últimos 4 dígitos do cartão</p>
                    <span>**** **** **** {aluno.card.lastNumbers}</span>
                  </Field>
                  <Field>
                    <p>Bandeira</p>
                    <span>{aluno.card.brand}</span>
                  </Field>
                  <Field>
                    <Link
                      href={`https://dash.pagar.me/merch_GJEQOK9ilt7lMP1b/acc_plNnPkWTwXFY4M3Z/customers/${aluno.customer_id}/info?page=1`}
                      target="_blank"
                      margin="22px"
                      color="#008001"
                    >
                      <BiLinkExternal />
                      Acessar aluno na Pagarme
                    </Link>
                  </Field>
                </div>
              </UserData>
              <SubscriberContainer>
                <h3>Informações da assinatura</h3>
                <Table stackable>
                  <Table.Header>
                    <Table.HeaderCell>
                      <Center>Id pedido</Center>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <Center>Data da assinatura</Center>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <Center>Valor Total</Center>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <Center>Parcelas</Center>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <Center>Próxima cobrança</Center>
                    </Table.HeaderCell>
                  </Table.Header>
                  <Table.Row>
                    <Table.Cell>
                      <Center>{aluno.id_pedido}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>{datePattern(aluno.created_at)} </Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>R${formatValue(aluno.totalValue)}</Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        {aluno.currentCycle}/{aluno.totalCycle}
                      </Center>
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        {aluno.currentCycle == aluno.totalCycle
                          ? "Encerrado"
                          : datePattern(aluno.nextBilling)}
                      </Center>
                    </Table.Cell>
                  </Table.Row>
                </Table>
              </SubscriberContainer>
              <SubscriberContainer>
                <h3>Faturas</h3>
                <Table stackable>
                  <Table.Header>
                    <Table.HeaderCell>
                      <Center>Data da cobrança</Center>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <Center>Valor</Center>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <Center>Status</Center>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <Center>Pagarme link</Center>
                    </Table.HeaderCell>
                    <Table.HeaderCell>
                      <Center>Opção</Center>
                    </Table.HeaderCell>
                  </Table.Header>

                  {aluno.fatures !== 0 &&
                    aluno.fatures.map((fature) => (
                      <Table.Row>
                        <Table.Cell>
                          <Center>{datePattern(fature.chargeDate)}</Center>
                        </Table.Cell>
                        <Table.Cell>
                          <Center>R${formatValue(fature.amount)} </Center>
                        </Table.Cell>
                        <Table.Cell>
                          <Center>
                            <Status status={fature.status} />
                          </Center>
                        </Table.Cell>
                        <Table.Cell>
                          <Center>
                            <Link
                              href={`https://dash.pagar.me/merch_GJEQOK9ilt7lMP1b/acc_plNnPkWTwXFY4M3Z/invoices/${fature.id}`}
                              target="_blank"
                            >
                              <BiLinkExternal /> Acessar fatura na Pagarme
                            </Link>
                          </Center>
                        </Table.Cell>
                        <Table.Cell>
                          {fature.status !== "paid" && (
                            <Center>
                              <Button onClick={() => setCharge(fature.charge)}>
                                Abrir
                              </Button>
                            </Center>
                          )}
                        </Table.Cell>
                      </Table.Row>
                    ))}
                </Table>
              </SubscriberContainer>
            </Content>
          )}
        </Container>
      </MainContainer>
    );
  }
  return <></>;
};

export default PagarmeAssinante;
